import { handleActions } from "redux-actions";
import {
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  UPDATE_USER_INIT,
  MY_INFO,
  MY_INFO_SUCCESS,
  MY_INFO_FAILURE,
  UPDATE_ADDRESS,
  UPDATE_ADDRESS_SUCCESS,
  UPDATE_ADDRESS_FAILURE,
  UPDATE_ADDRESS_INIT
} from "../actionCreators";

const initialState = {
  isUpdatingUser: false,
  updateUserErrorReason: null,
  isUpdatedUser: false,

  myInfo: null,
  isLoadingMyInfo: false,
  myInfoError: null,

  isUpdatingAddress: false,
  isAddressUpdated: false,
  updateAddressError: null
};

const updateUserReducer = handleActions(
  {
    [UPDATE_USER]: state => ({
      ...state,
      isUpdatingUser: true
    }),
    [UPDATE_USER_SUCCESS]: state => ({
      ...state,
      isUpdatingUser: false,
      isUpdatedUser: true,
      updateUserErrorReason: null
    }),
    [UPDATE_USER_FAILURE]: (state, { payload: error }) => ({
      ...state,
      isUpdatingUser: false,
      isUpdatedUser: false,
      updateUserErrorReason: error
    }),
    [UPDATE_USER_INIT]: state => ({
      ...state,
      isUpdatingUser: false,
      isUpdatedUser: false,
      updateUserErrorReason: null
    }),

    [MY_INFO]: state => ({
      ...state,
      isLoadingMyInfo: true,
      myInfoError: null
    }),
    [MY_INFO_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      isLoadingMyInfo: false,
      myInfo: (data && data.myInfo) || null,
      myInfoError: null
    }),
    [MY_INFO_FAILURE]: (state, { payload: error }) => ({
      ...state,
      isLoadingMyInfo: false,
      myInfoError: error
    }),

    [UPDATE_ADDRESS]: state => ({
      ...state,
      isUpdatingAddress: true,
      isAddressUpdated: false,
      updateAddressError: null
    }),
    [UPDATE_ADDRESS_SUCCESS]: state => ({
      ...state,
      isUpdatingAddress: false,
      isAddressUpdated: true,
      updateAddressError: null
    }),
    [UPDATE_ADDRESS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      isUpdatingAddress: false,
      isAddressUpdated: false,
      updateAddressError: error
    }),
    [UPDATE_ADDRESS_INIT]: state => ({
      ...state,
      isUpdatingAddress: false,
      isAddressUpdated: false,
      updateAddressError: null
    })
  },
  initialState
);

export default updateUserReducer;
